import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  hintText: {
    fontSize: '13px',
    lineHeight: '20px',
    color: theme.palette.text.secondary,
  },
  selectRoot: {
    borderRadius: '8px',
    '& .MuiSelect-root': {
      height: '32px',
      padding: '0px 16px 0px',
      display: 'flex',
      alignItems: 'center',
      width: '160px',
      fontSize: '13px',
    },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
